export default class Banner {
    constructor() {
        this.sections = document.querySelectorAll('.block-banner');
        this.init();
    }

    init() {
        this.sections.forEach((section) => {
            const items = [...section.querySelectorAll('.banner-item')];
            if (!items.length) return;

            let active = items[0];
            active.classList.add('is-active');
            this.openContent(active);
            section.classList.add('is-initialized');

            const activate = (item) => {
                if (item === active) return;
                this.flip(items, item);
                active = item;
            };

            items.forEach((item) => {
                item.querySelector('.banner-trigger')?.addEventListener('click', () => activate(item));
            });
        });
    }

    flip(items, to) {
        this.closeAll(items);

        items.forEach((el) => el.classList.remove('is-active'));
        items.forEach((el) => el.querySelector('.banner-trigger')?.setAttribute('aria-expanded', 'false'));
        to.classList.add('is-active');
        const trigger = to.querySelector('.banner-trigger');
        trigger?.setAttribute('aria-expanded', 'true');
        trigger?.setAttribute('aria-hidden', 'true');
        trigger?.setAttribute('inert', '');

        clearTimeout(this._contentTimeout);
        this._contentTimeout = setTimeout(() => {
            this.openContent(to);
        }, 300);
    }

    openContent(item) {
        const content = item.querySelector('.content');
        const trigger = item.querySelector('.banner-trigger');
        trigger?.setAttribute('aria-expanded', 'true');
        trigger?.setAttribute('aria-hidden', 'true');
        trigger?.setAttribute('inert', '');
        content?.classList.add('opacity-100', 'max-h-[500px]', 'pointer-events-auto');
        content?.classList.remove('opacity-0', 'max-h-0', 'pointer-events-none');
        content?.setAttribute('aria-hidden', 'false');
        content?.removeAttribute('inert');
    }

    closeAll(items) {
        items.forEach((item) => {
            const content = item.querySelector('.content');
            const trigger = item.querySelector('.banner-trigger');
            trigger?.setAttribute('aria-hidden', 'false');
            trigger?.removeAttribute('inert');
            content?.classList.add('opacity-0', 'max-h-0', 'pointer-events-none');
            content?.classList.remove('opacity-100', 'max-h-[500px]', 'pointer-events-auto');
            content?.setAttribute('aria-hidden', 'true');
            content?.setAttribute('inert', '');
        });
    }
}

if (document.querySelector('.block-banner')) {
    new Banner();
}
